import React from "react";
import { Link } from "react-router-dom";
import { Star, MapPin, Sparkles } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import FavoriteButton from "@/components/FavoriteButton";

export default function PoolCard({ pool }) {
  const { t, user } = useApp();
  const cover = pool.photos?.[0] ? fileUrl(pool.photos[0]) : "https://images.unsplash.com/photo-1582533568805-78a15dcb01b5?w=800&q=80";
  const halfBase = +(pool.price_per_day * (pool.half_day_price_pct ?? 0.6)).toFixed(2);
  const fullDisc = pool.full_day_discount_price && pool.full_day_discount_price > 0 ? pool.full_day_discount_price : null;
  const halfDisc = pool.half_day_discount_price && pool.half_day_discount_price > 0 ? pool.half_day_discount_price : null;
  return (
    <Link to={`/pool/${pool.pool_id}`} className="pool-card block bg-white border border-border rounded-2xl overflow-hidden group" data-testid={`pool-card-${pool.pool_id}`}>
      <div className="relative aspect-[4/3] overflow-hidden bg-muted">
        <img src={cover} alt={pool.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        {(fullDisc || halfDisc) && (
          <div className="absolute top-3 left-3 bg-[#E27B58] text-white px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wide shadow-md">SALE</div>
        )}
        {user?.role === "guest" && <div className="absolute top-3 right-3"><FavoriteButton poolId={pool.pool_id} /></div>}
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-2 mb-1">
          <h3 className="font-display text-lg font-semibold leading-tight tracking-tight">{pool.title}</h3>
          {pool.review_count > 0 && (
            <div className="flex items-center gap-1 text-sm shrink-0">
              <Star className="w-4 h-4 fill-[#E27B58] text-[#E27B58]" />
              <span className="font-semibold">{pool.rating_avg.toFixed(1)}</span>
              <span className="text-muted-foreground">({pool.review_count})</span>
            </div>
          )}
        </div>
        <div className="text-sm text-muted-foreground mb-2">{pool.hotel_name}</div>
        <div className="flex items-center gap-1 text-xs text-muted-foreground mb-3">
          <MapPin className="w-3.5 h-3.5" /><span>{pool.city}, {pool.country}</span>
        </div>
        {pool.daily_offer && (
          <div className="mb-3 inline-flex items-center gap-1.5 bg-green-500 text-white text-xs font-bold px-2.5 py-1 rounded-lg shadow-sm" data-testid={`card-offer-${pool.pool_id}`}>
            <Sparkles className="w-3 h-3" /> {pool.daily_offer}
          </div>
        )}
        <div className="grid grid-cols-2 gap-2 pt-2 border-t border-border">
          <div>
            <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{t("pool.slotFull")}</div>
            {fullDisc ? (
              <div className="text-sm"><span className="line-through text-muted-foreground text-xs mr-1">€{pool.price_per_day}</span><span className="font-bold text-[#E27B58]">€{fullDisc}</span></div>
            ) : (
              <div className="text-sm font-bold">€{pool.price_per_day}</div>
            )}
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{t("pool.slotHalf")}</div>
            {halfDisc ? (
              <div className="text-sm"><span className="line-through text-muted-foreground text-xs mr-1">€{halfBase}</span><span className="font-bold text-[#E27B58]">€{halfDisc}</span></div>
            ) : (
              <div className="text-sm font-bold">€{halfBase}</div>
            )}
          </div>
        </div>
        <div className="mt-2 text-[10px] font-semibold text-[#005C7A]/80 uppercase tracking-wider">Da pagare in loco</div>
      </div>
    </Link>
  );
}
